import { NewPageList } from "./new-page-list";

export class ProfileForThisEvent {
    about: string;
    isEmailVisible: boolean = true;
    fileCMId: string = null;
    isPhoneNumberVisible: boolean = false;
    isProfileImageVisible: boolean = true;
    name: string = null;
    profileImageUri: string;
    email: string = null;
    // fileName: string;
    phoneNo: string;
    updatedAt: number;
    updatedAtImage: number;
    organization: string;
    designation: string;
    aboutList = new Array<NewPageList>();
}


// WEBPACK FOOTER //
// /app/src/app/core/models/profileForThisEvent.ts